export const ENV = {
  LOCAL: 'local',
  QA: 'qa',
  STAGING: 'staging',
  PRODUCTION: 'production'
};
